// extracted by mini-css-extract-plugin
export var navigationContainer = "styles-module--navigationContainer--dluoL";
export var logoLink = "styles-module--logoLink--SbuhO";
export var logo = "styles-module--logo--U46rG";
export var navListContainer = "styles-module--navListContainer--hp7-B";
export var navItem = "styles-module--navItem--9zRg+";
export var link = "styles-module--link--4Z8Zq";
export var linkText = "styles-module--linkText--Lby7i";